import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C14A3C70-357F-4AE8-963C-B45ED543A4DB
 * name tooltip-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip-outline.svg
 * tags
 * - Tooltip 
 */
export const TooltipOutlineIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4Z" /></>, 'TooltipOutlineIcon');
export default TooltipOutlineIcon